<template>
    <ul class="done">
        <van-list
                v-model="loading"
                :finished="finished"
                :offset="10"
                finished-text="没有更多了"
                @load="onLoad">
            <li v-for="(item,index) in listData" :key="index" @click="toInfo(item.id)">
                <div class="top">
                    <div>价格：<span>{{item.price}} RMB</span></div>
                    <div>类型：<span style="color: #ff4d30;">{{stateInfo(item.status)}}</span></div>
                </div>
                <div class="center">
                    <div>数量：<span>{{item.num}} {{item.coin.toLocaleUpperCase()}}</span></div>
                    <div>总额：<span>{{item.num * item.price}}</span></div>
                </div>
                <div class="bottom">
                    <div>商家：<span>{{item.uname}}</span></div>
                    <button>已销毁</button>
                </div>
            </li>
        </van-list>
    </ul>
</template>

<script>
    // 微信图片
    import wx from "@/assets/img/c2c/wx@3x.png"
    import wx_active from "@/assets/img/c2c/wx_active@3x.png"
    // 支付宝图片
    import ali from "@/assets/img/c2c/ali@3x.png"
    import ali_active from "@/assets/img/c2c/ali_active@3x.png"
    // 银联图片
    import yl from "@/assets/img/c2c/yl@3x.png"
    import yl_active from "@/assets/img/c2c/yl_active@3x.png"

    export default {
        name: "done",
        data() {
            return {
                wx,
                wx_active,
                ali,
                ali_active,
                yl,
                yl_active,
                page: 0,
                total: null,
                loading: false,
                finished: false,
                listData: []
            }
        },
        methods: {
            getData() {
                this.page++;
                this.ajax.post('appapi/c2c/okorder', {page: this.page,}).then((res) => {
                    if (res.data.code === 1) {
                        this.listData.push(...res.data.data.data);
                        this.total = res.data.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.listData.length >= this.total) {
                            console.log("加载完成");
                            this.finished = true;
                        }
                    }
                })
            },
            onLoad() {
                setTimeout(() => {
                    this.getData();
                }, 500);
            },
            stateInfo(state) {
                console.log(state);
                switch (state) {
                    case 1:
                        return "未付款";
                    case 2:
                        return "待确认";
                    case 3:
                        return "完成";
                    case -1:
                        return "撤销";
                    case 4:
                        return "申诉中";
                }
            },
            toInfo(id) {
                this.$router.push({path: "/c2cOrder", query: {id: id}});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .done {
        margin-top: 44px;
        padding: 0 39px 100px 37px;

        li {
            padding: 22px 38px 28px;
            background: #fff;
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.5);
            border-radius: 20px;
            margin-bottom: 27px;

            .idBox {
                margin-bottom: 49px;
                font-size: 24px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 20px;
            }

            .top, .center, .bottom {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;

                div {
                    font-size: 24px;
                    font-weight: bold;
                    color: rgba(119, 119, 119, 1);
                    line-height: 20px;

                    span {
                        color: #1fc26d;
                    }
                }

                button {
                    width: 107px;
                    height: 41px;
                    line-height: 41px;
                    font-size: 22px;
                    font-weight: bold;
                    color: #fff;
                    box-shadow: 0 1px 15px 0 rgba(131, 131, 131, 0.2);
                    border-radius: 25px;
                    background: #FF4D30;
                }
            }

            .bottom {
                margin-bottom: 0;
            }
        }
    }
</style>
